module.exports = "/_next/static/images/198e6855312a6c1e3e989f7f90b44627-card-and-phone-3d-xs@1x.jpg";